export type ConstructionInput = { concreteKg: number; steelKg: number; insulation: 'mineral'|'foam'|'cellulose' };
export type ConstructionFootprint = { totalKg: number; breakdown: { concrete:number; steel:number; insulation:number } };

// Factors (kg CO2e per kg material) — demo values
const F = { concrete: 0.12, steel: 1.9, mineral: 1.2, foam: 3.0, cellulose: 0.6 };

export function embodiedCarbon(i: ConstructionInput): ConstructionFootprint {
  const concrete = i.concreteKg * F.concrete;
  const steel = i.steelKg * F.steel;
  const ins = (i.insulation==='mineral'? F.mineral : i.insulation==='foam'? F.foam : F.cellulose) * 100; // assume 100 kg default per unit
  const total = concrete + steel + ins;
  return { totalKg: parseFloat(total.toFixed(2)), breakdown: { concrete: parseFloat(concrete.toFixed(2)), steel: parseFloat(steel.toFixed(2)), insulation: parseFloat(ins.toFixed(2)) } };
}



















